export const LIST_CREDIT_LIMIT_REQUEST = 'LIST_CREDIT_LIMIT_REQUEST'
export const LIST_CREDIT_LIMIT_SUCCESS = 'LIST_CREDIT_LIMIT_SUCCESS'
export const LIST_CREDIT_LIMIT_FAIL = 'LIST_CREDIT_LIMIT_FAIL'

export const DETAIL_CREDIT_LIMIT_REQUEST = 'DETAIL_CREDIT_LIMIT_REQUEST'
export const DETAIL_CREDIT_LIMIT_SUCCESS = 'DETAIL_CREDIT_LIMIT_SUCCESS'
export const DETAIL_CREDIT_LIMIT_FAIL = 'DETAIL_CREDIT_LIMIT_FAIL'

export const CREATE_CREDIT_LIMIT_REQUEST = 'CREATE_CREDIT_LIMIT_REQUEST'
export const CREATE_CREDIT_LIMIT_SUCCESS = 'CREATE_CREDIT_LIMIT_SUCCESS'
export const CREATE_CREDIT_LIMIT_FAIL = 'CREATE_CREDIT_LIMIT_FAIL'

export const UPDATE_CREDIT_LIMIT_REQUEST = 'UPDATE_CREDIT_LIMIT_REQUEST'
export const UPDATE_CREDIT_LIMIT_SUCCESS = 'UPDATE_CREDIT_LIMIT_SUCCESS'
export const UPDATE_CREDIT_LIMIT_FAIL = 'UPDATE_CREDIT_LIMIT_FAIL'

export const DELETE_CREDIT_LIMIT_REQUEST = 'DELETE_CREDIT_LIMIT_REQUEST'
export const DELETE_CREDIT_LIMIT_SUCCESS = 'DELETE_CREDIT_LIMIT_SUCCESS'
export const DELETE_CREDIT_LIMIT_FAIL = 'DELETE_CREDIT_LIMIT_FAIL'
